'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'cannon';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e642';
var svgPathData = ['M77.5 393.3c-31.6-63.2-6-140 57.1-171.7c23.9-11.6 94.6-38.2 174-67c78.9-28.6 165.1-59 218.8-77.8c22.7-7.9 47.6 2.3 58.4 23.9l30.7 61.4c10.8 21.6 4 47.7-16 61c-23 15.4-52.9 35.4-86.1 57.5C488.2 246.2 446.7 224 400 224c-79.5 0-144 64.5-144 144c0 24.9 6.3 48.3 17.4 68.7c-10.2 6.1-18.4 10.8-24.2 13.8c-63.2 31.5-140 5.9-171.6-57.3zm437-112.6c1.8 2.4 3.6 4.9 5.3 7.4c-1.7-2.5-3.5-5-5.3-7.4z', 'M281.8 450.3c-10.6 6.4-19.3 11.3-25.4 14.5c-56.1 28.1-121.8 16-164.5-25.2c0 0 .1 .1 .1 .1L69.5 450.9c-23.7 11.9-52.5 2.2-64.4-21.5s-2.2-52.5 21.5-64.4l22.5-11.3s0 0 0 0c-7.3-58.9 22.5-118.6 78.5-146.6c49.5-24 287.2-107.9 394.6-145.5c30.3-10.6 63.6 3.1 78 31.8L630.9 155c14.4 28.7 5.3 63.6-21.4 81.5c-23.1 15.5-53.1 35.6-86 57.4c-2.8-4.6-5.8-9-9-13.2c32.9-21.9 63-42 86.1-57.5c19.9-13.4 26.8-39.4 16-61l-30.7-61.4C575 79.1 550.1 68.9 527.4 76.8C473.8 95.6 387.6 126 308.6 154.6c-79.3 28.8-150.1 55.4-174 67C71.5 253.2 45.9 330.1 77.5 393.3s108.4 88.8 171.6 57.3c5.8-3 14.1-7.7 24.2-13.8c2.6 4.7 5.4 9.2 8.4 13.6zM52 369.7c0 .2 .1 .3 .1 .5l-18.4 9.2c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l18.4-9.2s0 0 0 0c-6.7-8.2-12.6-17.2-17.5-27c-5-10-8.7-20.3-11.2-30.7zM496 368a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-208 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm136 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCannon = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;